class m {
  /**
   * Div element which holds the input or placeholder text for a textarea element.
   */
  measuringElement;
  constructor() {
    this.measuringElement = this.createElement();
  }
  /**
   * @returns An element for measuring text.
   */
  createElement() {
    const e = document.createElement("div");
    return e.classList.add("textarea-content-measurement"), e;
  }
  /**
   * Adds content to the innerHTML of the measuring element.
   *
   * @param text The text to be set.
   */
  populateWithText(e) {
    this.measuringElement.innerHTML = e.replaceAll(
      `
`,
      // An html line break followed by a zero width non breaking space.
      "<br/>&#8288;"
    );
  }
  /**
   * Add the measuring element to the body.
   */
  addToBody() {
    document.body.appendChild(this.measuringElement);
  }
  /**
   * Removes the measuring element from the body.
   */
  removeFromBody() {
    this.measuringElement.remove();
  }
  /**
   * Adds the padding from a element passed in as margin to the measuring element. This helps with correct sizing of placeholder text.
   *
   * @param element to use to set the margin of the measuring element.
   */
  addMarginToElement(e) {
    const t = getComputedStyle(e).padding;
    this.measuringElement.style.margin = t;
  }
  getTextHeight(e) {
    this.populateWithText(e), this.addToBody();
    const t = this.measuringElement.offsetHeight;
    return this.removeFromBody(), t;
  }
}
export {
  m as TextareaContentMeasurementElement
};
//# sourceMappingURL=textarea-content-measurement-element.js.map
